import { BaseParser, DATA_TYPE_CONC } from './baseExtractor';

const iconConcFile = 'concentrationFile.png';


class ConcentrationExtractor extends BaseParser {
  // eslint-disable-next-line no-unused-vars
  async _doParse(parent, fileName, data, report) {
      const returnValue = this.getNewReturnValue();
      const lines = data.split('\n');
      const outArray = [];
      for (let j = 0; j < lines.length; j++) {
        const splitLine = lines[j].split('\t');
        if (splitLine.length < 2) {
          returnValue.warnings.push(`The element in line ${j} could not be extracted: ${lines[j]}`);
          continue;
        }
        const Xval = parseFloat(splitLine[0]);
        const concentration = parseFloat(splitLine[1]);
        if (!Number.isNaN(Xval) && !Number.isNaN(concentration)) {
          outArray.push([Xval, concentration]);
        } else {
          returnValue.warnings.push(`The element in line ${j} could not be extracted. The values should be numbers`);
          continue;
        }
      }
      returnValue.processedData = outArray;
      returnValue.success = outArray.length > 0;
      returnValue.icon = iconConcFile;
      returnValue.dataType = DATA_TYPE_CONC;
      return returnValue;
  }
    
}

export{
  ConcentrationExtractor,
};
